import { render, staticRenderFns } from "./LinkedContent.vue?vue&type=template&id=c614690e&scoped=true"
import script from "./LinkedContent.vue?vue&type=script&lang=js"
export * from "./LinkedContent.vue?vue&type=script&lang=js"
import style0 from "./LinkedContent.vue?vue&type=style&index=0&id=c614690e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c614690e",
  null
  
)

export default component.exports